<template>
  <v-layout
    justify-center
    >
    <v-flex
      md8
      sm10
      xs12>
      <v-card
        class="main--text"
        >
        <v-form>
          <v-container
            grid-list-md
            fluid>
            <v-layout
              justify-start
              align-center>
              <v-flex><h3>お子さま情報入力フォーム</h3></v-flex>
            </v-layout>
            <v-layout
            >
              <v-flex
                md12>
                <v-text-field
                  v-model="personalName"
                  label="名"
                  type="text"
                  v-validate="'required'"
                  data-vv-name="personalName"
                  data-vv-as="名前"
                  required
                  :error-messages="errors.collect('personalName')"
                >
                </v-text-field>
              </v-flex>
            </v-layout>
            <v-layout
              >
              <v-flex
                md12>
                <v-text-field
                  v-model="flatPersonalName"
                  label="メイ"
                  type="text"
                  v-validate="'required'"
                  data-vv-name="flatPersonalName"
                  data-vv-as="名前（カナ）"
                  required
                  :error-messages="errors.collect('flatPersonalName')"
                >
                </v-text-field>
              </v-flex>
            </v-layout>
            <v-layout
              row>
              <v-flex>
                <v-radio-group
                  v-model="gender"
                  row
                  v-validate="'required'"
                  data-vv-name="gender"
                  data-vv-as="性別"
                  required
                  :error-messages="errors.collect('gender')"
                  >
                  <v-radio
                    label="男性"
                    value="male">
                  </v-radio>
                  <v-radio
                    label="女性"
                    value="female">
                  </v-radio>
                </v-radio-group>
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap>
              <v-flex
                xs12 sm6 md6>
                <BirthdayPicker
                  v-model="birthday"/>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex
                class="font-weight-bold"
                >受講希望時間帯</v-flex>
            </v-layout>
              <div
                v-for="(availableSchedule, index) in availableSchedules"
                :key="index"
              >
                <span class="caption">
                  時間帯{{index+1}}
                </span>
                <ScheduleSelector
                  v-model="availableSchedules[index]"
                  @addNewLine="$emit('add-schedule-button-click')"
                  @deleteLine="$emit('delete-schedule-button-click', index)"/>
              </div>
            <v-layout
              justify-start
              >
              <v-btn
                depressed
                rounded
                outlined
                color="primary"
                @click="submit()"
                >登録
              </v-btn>
            </v-layout>
          </v-container>
        </v-form>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import VStudentProfileSetDialog from "@/components/organisms/parent/VStudentProfileSetDialog.vue"
import BirthdayPicker from "@/components/molecules/BirthdayPicker.vue"
import ScheduleSelector from "@/components/molecules/ScheduleSelector.vue"

export default {
  components: {
    BirthdayPicker,
    ScheduleSelector
  },
  props: {
    value: Object
  },
  data() {
    return {
      birthdayMenu: null
    }
  },
  methods: {
    submit: function() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$emit("submit-button-click")
        }
      })
    },
    updateValue (diff) {
      this.$emit("input", { ...this.value, ...diff })
    }
  },
  computed: {
    personalName: {
      get() {
        return this.value.personalName
      },
      set(personalName) {
        this.updateValue({ personalName })
      }
    },
    flatPersonalName: {
      get() {
        return this.value.flatPersonalName
      },
      set(flatPersonalName) {
        this.updateValue({ flatPersonalName })
      }
    },
    gender: {
      get() {
        return this.value.gender
      },
      set(gender) {
        this.updateValue({ gender })
      }
    },
    birthday: {
      get() {
        return this.value.birthday
      },
      set(birthday) {
        this.updateValue({ birthday })
      }
    },
    availableSchedules: {
      get() {
        return this.value.availableSchedules
      },
      set(availableSchedule) {
        this.updateValue({ availableSchedules })
      }
    }
  },
  created: function () {
  }
}
</script>

<style scoped>
.error-message {
  color: red
}
</style>
